import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function SystemSection() {
  return <section className="py-12 bg-aged-cream relative overflow-hidden" data-id="element-308">
      <div className="container mx-auto px-4" data-id="element-309">
        <div className="max-w-4xl mx-auto" data-id="element-310">
          <div className="text-center mb-16" data-id="element-311">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-312">
              La verdad que nadie te dijo
            </motion.h2>
            <p className="text-xl text-slate-600 mb-8" data-id="element-313">
              El problema no es que gastes mal. El problema es que nunca te
              enseñaron un sistema:
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto mb-12" data-id="element-314">
              {['Visual', 'Simple', 'Adaptado a la quincena', 'Emocionalmente sostenible'].map((item, i) => <div key={i} className="bg-aged-green p-4 rounded-xl border-t-4 border-[#f4c430] shadow-md" data-id="element-315">
                  <p className="font-bold text-white" data-id="element-316">{item}</p>
                </div>)}
            </div>

            <p className="text-lg text-slate-600 mb-4" data-id="element-317">
              Te dieron consejos sueltos. Nunca una estructura.
            </p>
            <p className="text-xl font-bold text-[#f4c430]" data-id="element-318">
              Y sin estructura, el dinero se riega.
            </p>
          </div>

          <div className="border-2 border-[#1a3d3d] p-1 rounded-2xl shadow-2xl mb-16" data-id="element-319">
            <div className="bg-white rounded-[14px] p-8 md:p-12" data-id="element-320">
              <h3 className="text-3xl font-bold text-slate-900 mb-6 text-center" data-id="element-321">
                Piénsalo así
              </h3>
              <div className="space-y-4 text-lg text-slate-700" data-id="element-322">
                <p data-id="element-323">El dinero es como agua.</p>
                <p data-id="element-324">
                  Si no lo canalizas, se va por todos lados. No porque el agua
                  sea mala. Sino porque no tiene un canal.
                </p>
                <p className="text-2xl font-bold text-[#f4c430] text-center mt-8" data-id="element-325">
                  El sobre es ese canal.
                </p>
                <p className="text-center text-slate-600" data-id="element-326">
                  No es magia. Es orden.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}